import { FormattedMessage } from "react-intl";
import { SidebarHeader } from "../Sidebar/Header";
import { ChangeList } from "./ChangeList";

interface ChangeLogSidebarProps {
  id: string;
  type: string;
  onClose: () => void;
}

export function ChangeLogSidebar({ id, type, onClose }: ChangeLogSidebarProps) {
  return (
    <>
      <SidebarHeader
        title={<FormattedMessage id="history" defaultMessage="history" />}
        back
        onClose={onClose}
      />

      <ChangeList id={id} type={type} />
    </>
  );
}
